import { Button } from "@tql/ui-components-react/tql/buttons";
import { memo } from "react";

import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

type PaymentActionsProps = {
	selectedCount: number;
	onPayLumpSum: () => void;
	onPaySelected: () => void;
	onExportCSV: () => void;
};

export const PaymentActions = memo<PaymentActionsProps>(
	({
		selectedCount,
		onPayLumpSum,
		onPaySelected,
		onExportCSV,
	}: PaymentActionsProps) => {
		const { isReady, isEnabled } = useFeatureFlagGate("traxLtlInvoicePayment");
		return (
			<div className={"payment-actions"}>
				{isEnabled && isReady ? (
					<>
						<Button onClick={onPaySelected}>Pay Selected</Button>
						<Button onClick={onPayLumpSum}>Pay Lump Sum</Button>
					</>
				) : null}
				<Button
					disabled={selectedCount === 0}
					onClick={onExportCSV}
					variant={"tertiary"}
				>
					<span className={"payment-export-label"}>
						Export Selected Invoices
					</span>
				</Button>
			</div>
		);
	},
);

PaymentActions.displayName = "PaymentActions";
